<template lang="pug">
v-breadcrumbs(:items='breadcrumbs', router)
  template(v-slot:divider)
    v-icon.icon-breadcrumb(size='24px') mdi-chevron-right
  template(v-slot:item='{ item }')

    v-chip(
      @click="showAll = true"
      v-if="!showAll && (item.index === 1) && items.length > VISIBLE_COUNT"
      label
      small
    )  ...

    router-link(style="color:inherit" :to='item.to || ""' v-else)
      v-breadcrumbs-item(ripple)
        span.font-weight-regular() {{ item.text }}
</template>

<script>
const VISIBLE_COUNT = 4;

export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      showAll: false,
      VISIBLE_COUNT,
    };
  },
  computed: {
    breadcrumbs() {
      if (this.items.length > VISIBLE_COUNT && !this.showAll) {
        return [this.items[0], { index: 1 }, this.items[this.items.length - 1]];
      }

      return this.items.map((item, index) => {
        if (index === this.items.length - 1) {
          item.disabled = true;
        }
        return { ...item, index };
      });
    },
  },
  methods: {},
};
</script>

<style lang="scss">
.v-breadcrumbs {
  padding-left: 0 !important;

}
</style>
